// src/pages/History/AncientHistory/HistoryPageRome.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Ancient_Rome.png';

export default function HistoryPageRome() {
  return (
    <TopicPage
      topicKey="Ancient Rome"
      title="History: Ancient Rome"
      backgroundImage={bg}
      startRoute="/History-Ancient-Rome-Go"
      scrollLabels={[
        "The Roman Republic",
        "The Roman Empire",
        "Culture, Law, and Decline",
      ]}
        backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
